"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsBilling = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const text_area_1 = require("client/components/material/text-area");
const router_1 = require("client/components/router");
const upload_modal_1 = require("client/components/upload-modal");
const store_1 = require("client/modules/sites/modules/sites-list/store");
const store_2 = require("client/modules/users/store");
const material_ui_1 = require("material-ui");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const app_settings_1 = require("shared/app-settings");
const store_3 = require("../../store");
require("./app-settings-billing.less");
// chenge this to the image Marshall will create
const defaultLogo = require("client/resources/gray_box.jpg");
const dummyAppSettings = {
    description: "",
    value: "",
    displayName: ""
};
let AppSettingsBilling = class AppSettingsBilling extends React.Component {
    constructor() {
        super(...arguments);
        // related to Logo
        this.uploadModal = false;
        this.showConfirmationDelete = false;
        this.showConfirmationReplace = false;
        this.upload = null;
        this.logoAppSetting = ramda_1.merge(dummyAppSettings, {});
        this.uploadedLogo = "";
        this.defaultLogo = "";
        this.imageFile = [];
        // related to Info
        this.isChanged = false;
        this.info = "";
        this.infoHeader = "";
        this.infoPlaceholder = "";
        this.infoAppSetting = ramda_1.merge(dummyAppSettings, {});
        this.settings = [];
        this.maxRows = null;
        this.maxRowSize = null;
        // related to generate pdf
        this.siteId = 0;
        this.dateOptions = [
            {
                id: 0,
                label: "January 1 - January 15",
                value: ["", "01", "15"].join("-")
            },
            {
                id: 1,
                label: "January 16 - January 31",
                value: ["", "01", "31"].join("-")
            },
            {
                id: 2,
                label: "February 1 - February 15",
                value: ["", "02", "15"].join("-")
            },
            {
                id: 3,
                label: "February 16 - February 28",
                value: ["", "02", "28"].join("-")
            },
            {
                id: 4,
                label: "February 16 - February 29",
                value: ["", "02", "29"].join("-")
            },
            {
                id: 5,
                label: "March 1 - March 15",
                value: ["", "03", "15"].join("-")
            },
            {
                id: 6,
                label: "March 16 - March 31",
                value: ["", "03", "31"].join("-")
            },
            {
                id: 7,
                label: "April 1 - April 15",
                value: ["", "04", "15"].join("-")
            },
            {
                id: 8,
                label: "April 16 - April 30",
                value: ["", "04", "30"].join("-")
            },
            {
                id: 9,
                label: "May 1 - May 15",
                value: ["", "05", "15"].join("-")
            },
            {
                id: 10,
                label: "May 16 - May 31",
                value: ["", "05", "31"].join("-")
            },
            {
                id: 11,
                label: "June 1 - June 15",
                value: ["", "06", "15"].join("-")
            },
            {
                id: 12,
                label: "June 16 - June 30",
                value: ["", "06", "30"].join("-")
            },
            {
                id: 13,
                label: "July 1 - July 15",
                value: ["", "07", "15"].join("-")
            },
            {
                id: 14,
                label: "July 16 - July 31",
                value: ["", "07", "31"].join("-")
            },
            {
                id: 15,
                label: "August 1 - August 15",
                value: ["", "08", "15"].join("-")
            },
            {
                id: 16,
                label: "August 16 - August 31",
                value: ["", "08", "31"].join("-")
            },
            {
                id: 17,
                label: "September 1 - September 15",
                value: ["", "09", "15"].join("-")
            },
            {
                id: 18,
                label: "September 16 - September 30",
                value: ["", "09", "30"].join("-")
            },
            {
                id: 19,
                label: "October 1 - October 15",
                value: ["", "10", "15"].join("-")
            },
            {
                id: 20,
                label: "October 16 - October 31",
                value: ["", "10", "31"].join("-")
            },
            {
                id: 21,
                label: "November 1 - November 15",
                value: ["", "11", "15"].join("-")
            },
            {
                id: 22,
                label: "November 16 - November 30",
                value: ["", "11", "30"].join("-")
            },
            {
                id: 23,
                label: "December 1 - December 15",
                value: ["", "12", "15"].join("-")
            },
            {
                id: 24,
                label: "December 16 - December 31",
                value: ["", "12", "31"].join("-")
            }
        ];
        this.availableDateOptions = async () => {
            const options = [];
            // const payPeriods = this.payPeriods;
            const currentDate = new Date();
            const month = currentDate.getMonth();
            const year = currentDate.getFullYear();
            const prevyear = String(year - 1);
            const twoYearsAgo = String(year - 2);
            // const nextyear = year + 1; // just for testing if isLeap year test works
            const isLeap = (year) => new Date(year, 1, 29).getDate() === 29;
            let removed;
            // create 3 separate dateOptions arrays that will be spliced individually based on leap year
            const dateOptionsCurrent = this.dateOptions.map(e => e);
            const dateOptionsPrevyear = this.dateOptions.map(e => e);
            const dateOptionsTwoYearsAgo = this.dateOptions.map(e => e);
            if (isLeap(year)) {
                removed = dateOptionsCurrent.splice(3, 1);
            }
            else {
                removed = dateOptionsCurrent.splice(4, 1);
            }
            if (isLeap(Number(prevyear))) {
                removed = dateOptionsPrevyear.splice(3, 1);
            }
            else {
                removed = dateOptionsPrevyear.splice(4, 1);
            }
            if (isLeap(Number(twoYearsAgo))) {
                removed = dateOptionsTwoYearsAgo.splice(3, 1);
            }
            else {
                removed = dateOptionsTwoYearsAgo.splice(4, 1);
            }
            // filter through dateOptions to get specified periods (from dev settings) in available options
            const startRanges = dateOptionsCurrent.map(e => e.label.split(" - ")[0]);
            const curDate = moment().date();
            const lastRange = curDate <= 14 ? 16 : 1;
            // const subMonth = curDate <= 14 ? 2 : 1; // to always get period one month ago
            const subMonth = curDate <= 14 ? 1 : 0; // to always get the previous period
            const endMonth = moment()
                .subtract(subMonth, "month")
                .format("MMMM");
            const lastRangeSearch = `${endMonth} ${lastRange}`;
            console.log("lastRangeSearch", lastRangeSearch);
            const lastRangeIndex = startRanges
                .map((d, i) => {
                if (d.includes(lastRangeSearch)) {
                    return i;
                }
                return null;
            })
                .filter(e => {
                if (e === null) {
                    return false;
                }
                return true;
            })[0];
            console.log("lastRangeIndex", lastRangeIndex);
            let index = lastRangeIndex;
            let indexYear = String(year);
            for (let realX = 1; realX <= this.payPeriods; realX++) {
                const x = realX - 1;
                // do not push this.dateOptions into options. push customized year arrays based on leap year instead
                // options.push(clone(this.dateOptions[index]));
                const currentOptionIndexToAdd = lastRangeIndex - x;
                if (currentOptionIndexToAdd < 0) {
                    if (24 + currentOptionIndexToAdd < 0) {
                        if (index === 0) {
                            options.push(ramda_1.clone(dateOptionsPrevyear[index]));
                            indexYear = prevyear;
                        }
                        else {
                            options.push(ramda_1.clone(dateOptionsTwoYearsAgo[index]));
                            indexYear = twoYearsAgo;
                        }
                        index = 48 + currentOptionIndexToAdd;
                        options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                        options[x].label = options[x].label + ` (${indexYear})`;
                    }
                    else {
                        if (index === 0) {
                            options.push(ramda_1.clone(dateOptionsCurrent[index]));
                            indexYear = String(year);
                        }
                        else {
                            options.push(ramda_1.clone(dateOptionsPrevyear[index]));
                            indexYear = prevyear;
                        }
                        index = 24 + currentOptionIndexToAdd;
                        options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                        options[x].label = options[x].label + ` (${indexYear})`;
                    }
                }
                else {
                    options.push(ramda_1.clone(dateOptionsCurrent[index]));
                    index = currentOptionIndexToAdd;
                    indexYear = String(year);
                    options[x].value = options[x].value.replace(/^/, `${indexYear}`);
                    options[x].label = options[x].label + ` (${indexYear})`;
                }
            }
            options.shift();
            this.currentDateRange = options[1].value;
            // console.log("date options", this.dateOptions);
            // console.log("options", options);
            // return full options array
            // return options;
            // do not return full options array with two year range - just the last two periods
            // return options.slice(1, 2);
            // do not return full options array with two year range - just the last 8 periods
            return options.slice(1, 9);
        };
        this.loadBillingLogo = async () => {
            const logoUpload = await store_3.appSettingsStore.loadBillingLogo();
            if (logoUpload) {
                this.defaultLogo = "";
                this.upload = logoUpload;
                this.uploadedLogo = logoUpload.filePath;
            }
            else {
                this.upload = null;
                this.uploadedLogo = "";
                this.defaultLogo = defaultLogo;
            }
        };
        this.resetObservables = () => {
            this.uploadModal = false;
            this.showConfirmationDelete = false;
            this.showConfirmationReplace = false;
            this.upload = null;
            this.logoAppSetting = ramda_1.merge(dummyAppSettings, {});
            this.uploadedLogo = "";
            this.imageFile = [];
            this.defaultLogo = "";
            this.isChanged = false;
            this.info = "";
            this.infoHeader = "";
            this.infoPlaceholder = "";
            this.infoAppSetting = ramda_1.merge(dummyAppSettings, {});
            this.settings = [];
            this.maxRows = null;
            this.maxRowSize = null;
        };
        this.onHandleImageUpload = () => {
            this.uploadModal = true;
        };
        this.onHandleClickCancelUpload = () => {
            this.uploadModal = false;
        };
        this.onHandleClickConfirmReplace = async () => {
            await this.handleAssetsUpload(this.imageFile);
            this.showConfirmationReplace = false;
        };
        this.handleAssetsUploadCheck = async (accepted) => {
            this.imageFile = accepted;
            this.uploadModal = false;
            if (this.logoAppSetting.value && this.logoAppSetting.value === "1") {
                this.showConfirmationReplace = true;
            }
            else {
                await this.handleAssetsUpload(this.imageFile);
            }
        };
        this.handleAssetsUpload = async (accepted) => {
            const settingId = String(this.logoAppSetting.id);
            await store_3.appSettingsStore.upload(accepted, settingId, "image");
            await this.loadBillingLogo();
            const resultLogo = await store_3.appSettingsStore.readSettings(app_settings_1.AppOption.BillingEntityLogo);
            this.logoAppSetting = resultLogo;
            this.imageFile = [];
            router_1.RouteManager.transitionTo(`/settings/billing`);
        };
        this.onHandleClickDeleteUpload = async () => {
            this.showConfirmationDelete = true;
        };
        this.onHandleClickConfirmDelete = async () => {
            const settingId = this.logoAppSetting.id;
            await store_3.appSettingsStore.deleteUpload(this.upload.id, settingId);
            await this.loadBillingLogo();
            const resultLogo = await store_3.appSettingsStore.readSettings(app_settings_1.AppOption.BillingEntityLogo);
            this.logoAppSetting = resultLogo;
            this.showConfirmationDelete = false;
        };
        this.handleSubmit = async () => {
            const result = await store_3.appSettingsStore.updateSettings(this.settings);
            const resultInfo = await store_3.appSettingsStore.readSettings(app_settings_1.AppOption.BillingEntityInformation);
            this.infoAppSetting = resultInfo;
            this.isChanged = false;
        };
        this.handleGenerate = async () => {
            const result = await store_3.appSettingsStore.generatePdf(this.startDate, this.currentDateRange, this.siteId);
            this.siteId = 0;
        };
        this.handleChangeString = () => (event, value) => {
            this.info = value;
            // restrict value to 60 characters/line, 6 rows max
            if (this.maxRowSize && this.maxRows) {
                const lines = this.info.split("\n");
                for (let i = 0; i < lines.length; i++) {
                    if (lines[i].length <= this.maxRowSize)
                        continue;
                    let j = 0;
                    let space = this.maxRowSize;
                    while (j++ <= this.maxRowSize) {
                        if (lines[i].charAt(j) === " ")
                            space = j;
                    }
                    lines[i + 1] = lines[i].substring(space + 1) + (lines[i + 1] || "");
                    lines[i] = lines[i].substring(0, space);
                }
                this.info = lines.slice(0, this.maxRows).join("\n");
            }
            this.settings[0].value = this.info;
            this.isChanged = this.info !== this.infoAppSetting.value;
        };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleChangeDate = async (value) => {
            this.currentDateRange = value;
            // create start date
            const enddateArray = this.currentDateRange.split("-");
            const arraytouse = enddateArray.slice(0, -1);
            if (enddateArray[2] === "15") {
                arraytouse.push("01");
            }
            else {
                arraytouse.push("16");
            }
            this.startDate = arraytouse.join("-");
            // const query = {
            //   startDate: this.startDate,
            //   endDate: this.currentDateRange
            // };
            // console.log("query in change date", query);
        };
    }
    get availableOptions() {
        const options = [];
        const isImbUser = store_2.usersStore.user.value.user;
        if (isImbUser) {
            if (store_1.sitesListStore.sites.value) {
                store_1.sitesListStore.sites.value.forEach((site, i) => {
                    const indexStandardizer = 1;
                    options.push({
                        id: i + indexStandardizer,
                        label: site.displayName || site.name,
                        value: site.id.toString()
                    });
                });
            }
        }
        else {
            const site = store_2.usersStore.user.value.site;
            const siteOption = {
                id: site.id,
                label: site.displayName || site.name,
                value: site.id.toString()
            };
            options.push(siteOption);
        }
        return options;
    }
    async componentDidMount() {
        this.loadBillingLogo();
        const resultTextareaSize = await store_3.appSettingsStore.getTextareaSize();
        this.maxRows = resultTextareaSize.maxRows;
        this.maxRowSize = resultTextareaSize.maxRowSize;
        // results from readSettings below will always be an AppSettings object and not an array,
        // because there is only one entry in app_settings table for that AppOption
        const resultLogo = await store_3.appSettingsStore.readSettings(app_settings_1.AppOption.BillingEntityLogo);
        this.logoAppSetting = resultLogo;
        const resultInfo = await store_3.appSettingsStore.readSettings(app_settings_1.AppOption.BillingEntityInformation);
        this.infoAppSetting = resultInfo;
        this.settings.push(resultInfo);
        if (resultInfo) {
            this.info = resultInfo.value;
            this.infoHeader = resultInfo.description;
            this.infoPlaceholder = resultInfo.displayName;
        }
        const payPeriods = await store_3.appSettingsStore.readSettings(app_settings_1.AppOption.EobPayPeriods, true);
        this.payPeriods = Number(payPeriods.value);
        // console.log("this.payperiods", this.payPeriods);
        // max pay Periods to load: 48 (2 years)
        if (this.payPeriods > 48) {
            this.payPeriods = 48;
        }
        // console.log("this.payperiods", this.payPeriods);
        this.options = await this.availableDateOptions();
        // create start date
        console.log("current date is in component did mount:", this.currentDateRange);
        console.log("current start date is in component did mount:", this.startDate);
        const enddateArray = this.currentDateRange.split("-");
        const arraytouse = enddateArray.slice(0, -1);
        if (enddateArray[2] === "15") {
            arraytouse.push("01");
        }
        else {
            arraytouse.push("16");
        }
        this.startDate = arraytouse.join("-");
        console.log("current start date is in component did mount 2:", this.startDate);
        console.log("current date is in component did mount 2:", this.currentDateRange);
    }
    componentWillUnmount() {
        this.resetObservables();
    }
    render() {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "main" },
                React.createElement("div", { className: "main-left" },
                    React.createElement("div", { className: "logo-avatar" },
                        React.createElement("div", { className: "logo-image" },
                            React.createElement("img", { src: this.uploadedLogo || this.defaultLogo })),
                        React.createElement("h3", null, "Billing Entity Logo"),
                        React.createElement("div", { className: "logo-upload__buttons" },
                            React.createElement(button_1.MaterialButton, { className: "logo-upload__buttons--button", onClick: this.onHandleImageUpload }, "Upload Logo"),
                            React.createElement(button_1.MaterialButton, { className: "logo-upload__buttons--button", onClick: this.onHandleClickDeleteUpload, disabled: !this.upload }, "Delete Logo")),
                        this.uploadModal && (React.createElement(upload_modal_1.UploadModal, { onCancel: this.onHandleClickCancelUpload, message: `Please select a Billing Entity logo to use in the clinic invoices.`, title: "Upload Logo", onDrop: this.handleAssetsUploadCheck })),
                        this.showConfirmationDelete && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Delete", cancelText: "Cancel", message: `Are you sure you want to delete the current logo? <br />`, onCancel: () => (this.showConfirmationDelete = false), onConfirm: this.onHandleClickConfirmDelete, title: "Confirm Deletion" })),
                        this.showConfirmationReplace && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm Upload", cancelText: "Cancel", message: `Are you sure you want to proceed?<br /><br />By confirming upload, the new logo will replace the current one.`, onCancel: () => {
                                this.showConfirmationReplace = false;
                                this.imageFile = [];
                            }, onConfirm: this.onHandleClickConfirmReplace, title: "Confirm Logo Replacement" })))),
                React.createElement("div", { className: "main-right" },
                    React.createElement("div", { className: "row" },
                        React.createElement("h3", null, this.infoHeader)),
                    React.createElement("div", { className: "row" },
                        React.createElement(text_area_1.MaterialTextArea, { className: "row__info", placeholder: this.infoPlaceholder, value: this.info || "", rows: this.maxRows, onChange: this.handleChangeString() })),
                    React.createElement("div", { className: "row__button" },
                        React.createElement(button_1.MaterialButton, { primary: true, className: "row__button--button", disabled: !this.isChanged, onClick: this.handleSubmit }, "Save")))),
            React.createElement("div", { className: "main" },
                React.createElement("div", { className: "check__header" },
                    React.createElement("div", { className: "edit-check-header" },
                        React.createElement("div", { className: "eob-header-form__headline" },
                            React.createElement("div", { className: "row" },
                                React.createElement(material_ui_1.Typography, { variant: "headline", gutterBottom: true }, "Generate Client Statement")),
                            React.createElement("br", null),
                            React.createElement(material_ui_1.Typography, { variant: "headline", gutterBottom: true }, "Select a Pharmacy")),
                        React.createElement("div", { className: "row" },
                            React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, value: String(this.siteId) || "" })),
                        React.createElement("br", null),
                        React.createElement("div", { className: "eob-header-form__headline" },
                            React.createElement(material_ui_1.Typography, { variant: "headline", gutterBottom: true }, "Select Pay Period")),
                        React.createElement("div", { className: "row" },
                            React.createElement(select_1.MaterialSelect, { options: this.options || [], required: true, searchable: true, label: "Pay Period", onSelect: this.handleChangeDate, value: String(this.currentDateRange) || "" })),
                        React.createElement("br", null),
                        React.createElement("div", { className: "row__button" },
                            React.createElement(button_1.MaterialButton, { primary: true, className: "row__button--button", disabled: !this.siteId, onClick: this.handleGenerate }, "Generate Pdf")),
                        React.createElement("br", null))))));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "uploadModal", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "showConfirmationDelete", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "showConfirmationReplace", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "upload", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "logoAppSetting", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "uploadedLogo", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "defaultLogo", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "imageFile", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "isChanged", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "info", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "infoHeader", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "infoPlaceholder", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "infoAppSetting", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "settings", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "maxRows", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "maxRowSize", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "payPeriods", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "currentDateRange", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "options", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], AppSettingsBilling.prototype, "dateOptions", void 0);
__decorate([
    mobx_1.computed
], AppSettingsBilling.prototype, "availableOptions", null);
__decorate([
    mobx_1.action
], AppSettingsBilling.prototype, "handleChangeDate", void 0);
AppSettingsBilling = __decorate([
    mobx_react_1.observer
], AppSettingsBilling);
exports.AppSettingsBilling = AppSettingsBilling;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-billing/app-settings-billing.tsx
// module id = 3172
// module chunks = 0